import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {InputTextareaModule} from "primeng/inputtextarea";
import {ButtonModule} from 'primeng/button';
import {NgClass} from "@angular/common";
import {firstValueFrom, forkJoin} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {MessageService} from "primeng/api";

@Component({
  selector: 'app-chat-input',
  standalone: true,
  imports: [
    FormsModule,
    InputTextareaModule,
    ButtonModule,
    NgClass
  ],
  template: `
    <div class="col-12 container--input--chat grid flex-column gap-2 ">
      <div class="col-6 w-full p-3 chat-input-box border-round-3xl
      relative
      shadow-4 field-text-container flex column">
        <div class="w-full">
          <textarea class="w-full border-none   max-h-9rem overflow-y-auto scrollbar-thin-gray
         chat-input-textarea" [autoResize]="true" pInputTextarea [(ngModel)]="inputText"
                    [maxlength]="maxLength" [placeholder]="translation.placeholder"
                    (keyup.enter)="changeValue()"
          ></textarea>
        </div>
        <div class="flex justify-content-end w-full">
          <button pButton type="button" class="bg-white button-action p-button-rounded p-button-icon-only"
                  [disabled]="isLoading" (click)="changeValue()">
            <i class="pi mx-2 text-black-alpha-80"
               [ngClass]="[isLoading ? 'pi-stop' : 'pi-send']"></i>
          </button>
        </div>
        <div class="input--footer">
          <small>{{ inputText.length }}/{{ maxLength }} </small>
        </div>
      </div>
    </div>
  `,
  styleUrl: './chat-input.component.scss'
})
export class ChatInputComponent implements OnInit {

  inputText: string = '';
  maxLength: number = 1_000;
  @Input()
  isLoading: boolean = false;
  translation: any = {};


  @Output('value')
  private valueEmitter: EventEmitter<string> = new EventEmitter();

  constructor(private _t: TranslateService, private messageService: MessageService) {
  }


  changeValue = () => {
    if (this.validateInput() && !this.isLoading)
      this.valueEmitter.emit(this.inputText);
  }

  ngOnInit(): void {
    this.getTranslations().then()
  }

  async getTranslations() {
    this.translation = await firstValueFrom(forkJoin({
      placeholder: this._t.get('components.app-chat.placeholder'),
      advertencia: this._t.get('common.advertencia'),
      camposRequeridos: this._t.get('components.app-chat.campo-requerido'),
    }))
  }

  validateInput(): boolean {
    if (!this.inputText || !this.inputText.trim()) {
      this.messageService.add({
        severity: 'warn',
        summary: this.translation.advertencia,
        detail: this.translation.camposRequeridos,
      });
      return false;
    }
    return true;
  }


  cleanInput(): void {
    this.inputText = '';
  }

}
